
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.018 8.406a4.074 4.074 0 100-8.148 4.074 4.074 0 000 8.148zm2.852 1.018h-.531a5.547 5.547 0 01-4.641 0h-.532A4.279 4.279 0 00.89 13.702v1.324c0 .844.684 1.528 1.527 1.528H13.62c.844 0 1.528-.684 1.528-1.528v-1.324a4.279 4.279 0 00-4.278-4.278z","fill":"#fff"}})])
          )
        }
      }
    